import { getPath as s } from "./index357.mjs";
import { setPath as m } from "./index350.mjs";
function f(o, { from: n, to: c }, r) {
  const t = s(o, r);
  if (!Array.isArray(t))
    return r;
  const e = [...t], i = t[n];
  return e.splice(n, 1), e.splice(c, 0, i), m(o, e, r);
}
export {
  f as reorderPath
};
